import createVueApp from '@phoenix/createVueApp';
import StoreList from '@maison/components/store/StoreList.vue';

document.querySelectorAll('.phoenix-store-list').forEach((el) => {
  const app = createVueApp();
  app.component('StoreList', StoreList);
  app.mount(el);
});
